import { render, staticRenderFns } from "./editorColourPicker.vue?vue&type=template&id=7c151b7e&scoped=true&"
import script from "./editorColourPicker.vue?vue&type=script&lang=js&"
export * from "./editorColourPicker.vue?vue&type=script&lang=js&"
import style0 from "./editorColourPicker.vue?vue&type=style&index=0&id=7c151b7e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c151b7e",
  null
  
)

export default component.exports